module.exports = __webpack_public_path__ + "img/jordbruk_paavirkning_jordbearbeiding_og_husdyr.371179fb.jpg";